export default __webpack_public_path__ + "static/media/paditransparent.eff93bb8.png";